

export const notixPalette = {
  actionColor: {
    active: 'rgba(1, 95, 78, 1)',
    hover: 'rgba(1, 127, 96, 0.75)',
    main: 'rgba(1, 127, 96, 1)',
    light: 'hsl(252, 46%, 92%)',
  },
};

export const selectCustomStyles = {
  option: (provided, { isFocused, isSelected }) => ({
    ...provided,
    color: (isFocused || isSelected) && '#fff',
    backgroundColor: isFocused
      ? notixPalette.actionColor.main
      : isSelected
        ? notixPalette.actionColor.active
        : undefined,
  }),
};

export const tagsInputTheme = {
  control: (_, states) => {
    return {
      borderColor: (states.isSelected || states.isFocused) ? 'rgba(1, 127, 96, 1)!important' : 'hsl(0,0%,80%)'
    }
  }
}
